import React from "react";
import { Provider } from "react-redux";
import { store } from "../../../../redux/store";
import WalkthroughContainer from "./WalkthroughContainer";

const ShowPage = ({ id, audience, default_host, logo_path }) => {
  const [style, setStyle] = React.useState({});

  return (
    <Provider store={store}>
      <WalkthroughContainer id={id} audience={audience} default_host={default_host} logo_path={logo_path} />
    </Provider>
  );
}

export default ShowPage;